import React from 'react'
import { useState, useEffect } from 'react'
import AdminNavbar from '../Navbar/AdminNavbar'
import UserNavbar from '../Navbar/UserNavbar'
import { AiFillFileExcel, AiFillFilePdf, AiOutlineFileText } from 'react-icons/ai'
import axios from 'axios'
import { toast } from 'react-toastify';
import { Button, DatePicker, Input, Select, Table, Checkbox, Tooltip, Spin } from 'antd';
import dayjs from 'dayjs';
import { Option } from 'antd/es/mentions';
import { useNavigate } from 'react-router-dom'
import { PaymentPendingReport, PaymentPendingSummary } from '../Api/All_Api'
import { getReportDataApi } from '../Api/CommonApi'
import TitleNavbar from '../Navbar/TitleNavbar'

const PaymentPendingSummery = () => {
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY"];

  const role = sessionStorage.getItem('role');

  const user = sessionStorage.getItem('userId');

  const branchId = sessionStorage.getItem('branchId');
  const sessionYear = sessionStorage.getItem('sessionYear');
  const year = sessionYear
  const navigate = useNavigate();
  useEffect(() => {
    if (!sessionYear) {
      sessionStorage.clear();
      navigate('/')
    }
  }, [])

  const [errors, setErrors] = useState({
    toDate: "",

    fromDate: "",
  });
  const [toDate, setToDate] = useState("");
  const [PaymentPending, setPaymentPending] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [viewButton, setViewButton] = useState(false);
  const [Type, setType] = useState(1);
  const [ID, setID] = useState(0);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(0);
  console.log("Admin", role);
  console.log("User", user);


  //======Search data from table===============
  const handleSearch = (value) => {
    const filtered = PaymentPending.filter((item) =>
      Object.values(item).some((val) =>
        val?.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
    setTotalEntries(filtered.length); // Update total entries count after filtering
    setCurrentPage(1);
  };
  // //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };

  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Mine Name",
      dataIndex: "mine_name",
      key: "mine_name",
    },
    {
      title: "Sale Bill No",
      dataIndex: "sale_bill_no",
      key: "sale_bill_no",
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
    },
    {
      title: " Vehicle Number",
      dataIndex: "vehicle_no",
      key: "vehicle_no",
    },
    {
      title: " Pending Amount",
      dataIndex: "total_amount",
      key: "total_amount",
    },




  ];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };


  // const handleID = async () => {
  //   if (role === 1) {
  //     setID(1);
  //     setUserId(0);
  //     console.log("InIf", role);
  //   } else {
  //     setID(2);
  //     setUserId(user);
  //     console.log("InElse", user);
  //   }
  //   console.log("ID======", ID);
  //   console.log("userId==", userId, ' ', user);
  // };

  // useEffect(() => {
  //   console.log("Updated ID: ", ID);
  //   console.log("Updated userId: ", userId);
  // }, [ID, userId]); // This will run whenever either ID or userId changes

  const handleSubmit = async (id,userid) => {
    // Validate the dates
    if (!fromDate || !toDate) {
      setErrors({
        ...errors,
        fromDate: fromDate ? "" : "From Date is required.",
        toDate: toDate ? "" : "To Date is required.",

      });
      return;
    }
    setLoading(true);
    const formattedFromDate = fromDate ? dayjs(fromDate).format('YYYY-MM-DD') : '';
    const formattedToDate = toDate ? dayjs(toDate).format('YYYY-MM-DD') : '';

    try {
      const response = await axios.get(`${PaymentPendingReport}?startDate=${formattedFromDate}&endDate=${formattedToDate}&reportId=${Type}&id=${id}&userId=${userid}&branchId=${branchId}&accYear=${year}`);
      console.log("Response data:", response);
      setLoading(false);
      let reportUrl = response.data;
      console.log("Response data:", response.data);
     if(reportUrl === "REPORT FILE NOT FOUND"){
             toast.warn('Report File Not Found...!!', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
      else {
    
        const reportLink = getReportDataApi + `output/${reportUrl}`;
        window.open(reportLink, "_blank");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during API call:", error);
      toast.error("Error occurred while submitting data");
    }

    setErrors({
      ...errors,
      fromDate: "",
      toDate: "",
     
    });



  };
  // ==============Get table data================

  let isError = false;

  const fetchPaymentPending = async (id,userid) => {
    if (!fromDate || !toDate || !Type) {
      setErrors({
        ...errors,
        fromDate: fromDate ? "" : "From Date is required.",
        toDate: toDate ? "" : "To Date is required.",
      
      });
      return;
    }
 setLoading(true);
    const formattedFromDate = fromDate ? dayjs(fromDate).format('YYYY-MM-DD') : '';
    const formattedToDate = toDate ? dayjs(toDate).format('YYYY-MM-DD') : '';
    
    try {
      const response = await axios.get(`${PaymentPendingSummary}?startDate=${formattedFromDate}&endDate=${formattedToDate}&reportId=${Type}&id=${id}&userId=${userid}&branchId=${branchId}&accYear=${year}`);

       if (response.data && Array.isArray(response.data)) {
          if (response.data.length > 0) {
            setPaymentPending(response.data);
            setFilteredData(response.data); 
            setTotalEntries(response.data.length);
            setViewButton(true);
          } else {
            setPaymentPending([]); // No data available, set empty
            setFilteredData([]); // Set empty filtered data
            console.log("No data available for the given date range .");
            toast.success("No data available for the given date range .");
          
          }
        }else if(response.data == "NOTFOUND"){
                                               setPaymentPending([]); // No data available, set empty
                                               setFilteredData([]); // Set empty filtered data
                                               console.log("No data available for the given date range .");
                                               toast.success("No data available for the given date range .");
                             
                                             } else {
          // Handle invalid data structure
          console.error('Invalid response data:', response.data);
          toast.error('Failed to fetch : Invalid data structure');
        }
      } catch (error) {
      if (!isError) {
        // Check if the error has already been triggered
        console.error("Error fetching Payment Pending:", error);
        toast.error("Failed to fetch Payment Pending data");
        isError = true; // Set the flag to prevent double toast
      }
     
    }
    finally{
      setLoading(false);
    }
    setErrors({
      ...errors,
      fromDate: "",
      toDate: "",

    });

  };


  const handleView = async () => {
    // await handleID();
    if (role == 1) {
      setID(1);
      setUserId(0);
      fetchPaymentPending(1,0);
    } else {
      setID(2);
      setUserId(user);
      fetchPaymentPending(2,user);
    }
  
 

  };

  const handleDownloadPDF = () => {

    if (role == 1) {
      setID(1);
      setUserId(0);
      handleSubmit(1,0);
    } else {
      setID(2);
      setUserId(user);
      handleSubmit(2,user);
    }
    setType(1); // Type for PDF download
   
  };

  const handleDownloadExcel = () => {
    if (role == 1) {
      setID(1);
      setUserId(0);
      handleSubmit(1,0);
    } else {
      setID(2);
      setUserId(user);
      handleSubmit(2,user);
    }
    setType(2); 
    // Type for Excel download
 console.log("Type",Type);
 
  };

  //===================================
  const navbg = {
    backgroundColor: "#f79400",
    boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
    display: "flex",
    alignItems: "center",
    padding: "5px 10px",
    fontSize: "19px",
    color: "#fff"
  }
  //=====================================================

  return (
    <>

      <AdminNavbar />

      <div className="p-0 m-0">

        <div
          className="row m-0"
          style={navbg}
        >
          <div
            className="col-12 "
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <span className="px-md-5"  style={{ flexGrow: 1 }}>
  
              <AiOutlineFileText /> &nbsp; Payment Pending Summary
            </span>
            <span >
            <TitleNavbar/>
            </span>
          </div> </div>

        <div className='row m-0 p-0 pt-5'>
          <div className='col-12 col-lg-3'></div>
          <div className='col-12 col-lg-6'>
            <div className="row px-md-5 mt-3  m-0">
              {/* <div className="col-12 pt-2 ">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels"  style={{fontSize:16}}>Type: </label>
                    </div>
                    <div className="col-9 col-lg-6">
                    <Select
                       value={Type || undefined}
                       onChange={(value) => setType(value)}
                           showSearch
                      className="w-100"
                     placeholder="Select Type"
                       optionFilterProp="children">
                                  <Select.Option value="1">
                                  Pdf
                                  </Select.Option>
                                  <Select.Option value="2">
                                   Excel
                                  </Select.Option>
                                 
                              </Select>
                             
                          {errors.Type && (
                            <div className="errorField">{errors.Type}</div>
                          )}
                    </div>
                  </div>
                </div> */}





              <div className="col-12 pt-2 ">
                <div className="row m-0">
                  <div className="col-3 p-0 lableStyle">
                    <label className="labels" style={{ fontSize: 16 }}>From Date: </label>
                  </div>
                  <div className="col-9 col-lg-6">
                    <DatePicker
                      defaultValue={null}
                      value={fromDate}
                      onChange={(value) => setFromDate(value)}
                      className="w-100"
                      format={dateFormatList}
                    />
                    {errors.fromDate && (
                      <div className="errorField">{errors.fromDate}</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-12 pt-2 ">
                <div className="row m-0">
                  <div className="col-3 p-0 lableStyle">
                    <label className="labels" style={{ fontSize: 16 }}>To Date: </label>
                  </div>
                  <div className="col-9 col-lg-6">
                    <DatePicker
                      defaultValue={null}
                      value={toDate}
                      onChange={(value) => setToDate(value)}
                      className="w-100"
                      format={dateFormatList}
                    />
                    {errors.toDate && (
                      <div className="errorField">{errors.toDate}</div>
                    )}
                  </div>
                </div>
              </div>



              <div className="col-12 text-center pt-3">
                <Button
                  type="submit"
                  className="SubmitBtn mx-1"
                  onClick={handleView}

                  disabled={loading}
                  >
                    {loading ? <Spin size="small" /> : 'View'} 
                </Button>


              </div>

              <div
                className="col-12 p-0 mt-3"
                style={{ borderBottom: "2px solid #bfb597" }}
              ></div>
            </div>
          </div>
          <div className='col-12 col-md-2 col-lg-4'></div>
        </div>

      </div>
      {/*================ Table =========================*/}
      {viewButton && (<div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
        <div className='col-12 col-md-2'></div>
        <div className="col-12 col-md-8 py-3 shadow border"
          style={{ marginBottom: "50px", backgroundColor: "white" }}
        >
          <div
            className="col-12 px-md-5"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
              <Select
                defaultValue={pageSize}
                onChange={handlePageSizeChange}
                style={{ width: 120, textAlign: "center" }}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
              </Select>
            </div>

            <div className="pt-4 pt-md-0" style={{ display: "flex", gap: "10px" }}>
              <Tooltip title="Download PDF" placement="top">
                <div

                  style={{
                    cursor: 'pointer',
                    fontSize: '24px',
                    color: '#D32F2F',
                    marginBottom: 16
                  }}
                  onClick={handleDownloadPDF}
                  disabled={loading}
                >
                  <AiFillFilePdf />
                </div>
              </Tooltip>
              <Tooltip title="Download Excel" placement="top">
                <div

                  style={{
                    cursor: 'pointer',
                    fontSize: '24px',
                    color: 'green',
                    marginBottom: 16
                  }}
                  onClick={handleDownloadExcel}
                  disabled={loading}
                >
                  <AiFillFileExcel />
                </div>
              </Tooltip>
              <Input.Search
                placeholder="Search"
                onSearch={handleSearch}
                style={{ width: 200, marginBottom: 16 }}
              />
            </div>
          </div>

          <div style={{ backgroundColor: "white" }}>
            <Table
              bordered
              style={{ padding: "0px 20px", overflowX: "auto" }}
              columns={columns}
              dataSource={filteredData}
              pagination={{
                pageSize: pageSize,
                total: totalEntries,
                showTotal: (total, range) =>
                  `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                current: currentPage,
                onChange: (page) => setCurrentPage(page),
              }}
              showSorterTooltip={false}
              rowKey={(record) => record.id}
              components={components}
            />
          </div>
        </div>

      </div>)}
      <div className='col-12 col-md-2'></div>
    </>
  )
}

export default PaymentPendingSummery